import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import PrivateRoute from './PrivateRoute/';
import PublicRoute from './PublicRoute/';
import RolesPrivateRoute from './RolesPrivateRoute';
import ChangePasswordRoute from './ChangePasswordRoute';
import routes from './routes';
import GridDashboard from '../components/GridDashboard';

import Login from '../pages/Login';
import ChangePassword from '../pages/ChangePassword';

export default function Router() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
          path=""
        />
        <Route
          path="dashboard"
          element={
            <PrivateRoute>
              <GridDashboard />
            </PrivateRoute>
          }
        >
          {routes.map((route, i) => (
            <Route
              element={
                <RolesPrivateRoute groups={route.groups} roles={route.roles}>
                  {route.import}
                </RolesPrivateRoute>
              }
              path={route.path}
              key={i}
            />
          ))}
        </Route>
        <Route
          path="changepassword"
          element={
            <ChangePasswordRoute>
              <ChangePassword />
            </ChangePasswordRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}
